/*
 * Module for the Contact Log Follow-Up page
 */
rs.module("content/system_/activity/messagecenterthreads/index",

    ["controls/data/grid"],

    function (gridModule) {
        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, backendUrl) {
            var filterForm = $.js(jsSelectors.filterForm);
            var includeClosed = filterForm.js(jsSelectors.includeClosed);

            includeClosed.on("change", function () {
                filterForm.js(jsSelectors.loadingSpinner).show();

                gridModule.update(
                    backendUrl,
                    {
                        includeClosedFlag: includeClosed[0].checked
                    },
                    lrsGridApi.agGridApi,
                    function done() {
                        filterForm.js(jsSelectors.loadingSpinner).hide();
                    }
                );
            });            
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);